<form [formGroup]="externalLoginSettingsForm" (ngSubmit)="saveExternalLoginSettings()">
  <div class="row g-4">
    <div class="col-12 col-lg-6">
      <div class="form-group pt-2 d-flex align-items-center">
        <input type="checkbox" id="samlLoginEnabled" formControlName="samlLoginEnabled" />
        <label class="ms-1 mb-0" for="samlLoginEnabled">
          {{ 'Settings::SamlLoginEnabled' | abpLocalization }}
        </label>
      </div>
      <div class="form-group mt-3">
        <label class="pl-1" for="samlLoginEndPoint">
          {{ 'Settings::SamlLoginEndPoint' | abpLocalization }}
        </label>
        <input
          type="text"
          id="samlLoginEndPoint"
          class="form-control form-control-sm"
          formControlName="samlLoginEndPoint" />
      </div>
      <div class="form-group mt-3">
        <label class="pl-1" for="samlDefaultRedirectEndPoint">
          {{ 'Settings::SamlDefaultRedirectEndPoint' | abpLocalization }}
        </label>
        <input
          type="text"
          id="samlDefaultRedirectEndPoint"
          class="form-control form-control-sm"
          formControlName="samlDefaultRedirectEndPoint" />
      </div>

      <div class="form-group mt-3">
        <button
          type="button"
          class="btn ca-btn ca-btn-neutral ms-1"
          (click)="onImportFormClick($event)">
          <i class="far fa-file-import"></i>
          <span>{{ 'Settings::ImportCertificate' | abpLocalization }}</span>
        </button>
        <span *ngIf="selectedCertFile" class="ms-2 small text-muted">
          {{ selectedCertFile.name }}
        </span>
      </div>
    </div>

    <div class="col-12 col-lg-6 border-lg-start ps-lg-4">
      <div class="form-group pt-2 d-flex align-items-center">
        <input type="checkbox" id="silentLoginEnabled" formControlName="silentLoginEnabled" />
        <label class="ms-1 mb-0" for="silentLoginEnabled">
          {{ 'Settings::SilentLoginEnabled' | abpLocalization }}
        </label>
      </div>

      <div class="form-group mt-3">
        <label class="pl-1" for="silentLoginMetadataUrl">
          {{ 'Settings::SilentLoginMetadataUrl' | abpLocalization }}
        </label>
        <input
          type="text"
          id="silentLoginMetadataUrl"
          class="form-control form-control-sm"
          formControlName="silentLoginMetadataUrl" />
      </div>

      <div class="form-group mt-3">
        <label class="pl-1" for="silentLoginValidIssuers">
          {{ 'Settings::SilentLoginValidIssuers' | abpLocalization }}
        </label>
        <input
          type="text"
          id="silentLoginValidIssuers"
          class="form-control form-control-sm"
          formControlName="silentLoginValidIssuers" />
      </div>

      <div class="form-group mt-3">
        <label class="pl-1" for="silentLoginValidAudiences">
          {{ 'Settings::SilentLoginValidAudiences' | abpLocalization }}
        </label>
        <input
          type="text"
          id="silentLoginValidAudiences"
          class="form-control form-control-sm"
          formControlName="silentLoginValidAudiences" />
      </div>

      <div class="form-group mt-3">
        <label class="pl-1" for="silentLoginUserIdentifierClaim">
          {{ 'Settings::SilentLoginUserIdentifierClaim' | abpLocalization }}
        </label>
        <input
          type="text"
          id="silentLoginUserIdentifierClaim"
          class="form-control form-control-sm"
          formControlName="silentLoginUserIdentifierClaim" />
      </div>

      <div class="form-group mt-3">
        <label class="pl-1" for="ssoHandoffAllowedOrigins">
          {{ 'Settings::SSOHandoffAllowedOrigins' | abpLocalization }}
        </label>
        <small class="form-text text-muted d-block pl-1">
          {{ 'Settings::SSOHandoffAllowedOriginsDescription' | abpLocalization }}
        </small>
        <input
          type="text"
          id="ssoHandoffAllowedOrigins"
          class="form-control form-control-sm"
          formControlName="ssoHandoffAllowedOrigins" />
      </div>

      <hr class="my-4" />

      <div class="form-group pt-2 d-flex align-items-center">
        <input
          type="checkbox"
          id="authCodeFlowSilentLoginEnabled"
          formControlName="authCodeFlowSilentLoginEnabled" />
        <label class="ms-1 mb-0" for="authCodeFlowSilentLoginEnabled">
          {{ 'Settings::AuthCodeFlowSilentLoginEnabled' | abpLocalization }}
        </label>
      </div>

      <div class="form-group mt-3">
        <label class="pl-1" for="authCodeFlowSilentLoginAuthority">
          {{ 'Settings::SilentLoginAuthority' | abpLocalization }}
        </label>
        <small class="form-text text-muted d-block pl-1">
          {{ 'Settings::SilentLoginAuthorityFormatHelp' | abpLocalization }}
        </small>
        <input
          type="text"
          id="authCodeFlowSilentLoginAuthority"
          class="form-control form-control-sm"
          formControlName="authCodeFlowSilentLoginAuthority" />
      </div>

      <div class="form-group mt-3">
        <label class="pl-1" for="authCodeFlowSilentLoginClientId">
          {{ 'Settings::SilentLoginClientId' | abpLocalization }}
        </label>
        <input
          type="text"
          id="authCodeFlowSilentLoginClientId"
          class="form-control form-control-sm"
          formControlName="authCodeFlowSilentLoginClientId" />
      </div>

      <div class="form-group mt-3">
        <label class="pl-1" for="authCodeFlowSilentLoginClientSecret">
          {{ 'Settings::SilentLoginClientSecret' | abpLocalization }}
        </label>
        <input
          type="password"
          id="authCodeFlowSilentLoginClientSecret"
          class="form-control form-control-sm"
          formControlName="authCodeFlowSilentLoginClientSecret" />
      </div>
    </div>
  </div>

  <button type="submit" class="btn btn-primary mt-3">
    <i class="me-1 fas fa-save"></i>
    {{ 'AbpUi::Save' | abpLocalization }}
  </button>
</form>

<input
  id="samlCertSelector"
  type="file"
  class="d-none"
  style="display: none"
  (click)="$event.target.value = ''"
  (change)="onImportForm($event.target.files)"
  [attr.accept]="acceptFileExtensions.join(',')" />
